import React from 'react';

const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    height="70px"
    viewBox="0 0 524.235 524.235"
    width="70px"
  >
    <g>
      <path
        d="m294.882 0h-262.117c-18.094 0-32.765 14.671-32.765 32.765v458.706c0 18.094 14.671 32.765 32.765 32.765h262.118c18.094 0 32.765-14.671 32.765-32.765v-458.706c-.001-18.094-14.671-32.765-32.766-32.765zm-65.529 294.882c-18.096 0-32.765-14.671-32.765-32.765 0-18.096 14.669-32.765 32.765-32.765s32.765 14.669 32.765 32.765c0 18.095-14.669 32.765-32.765 32.765z"
        data-original="#000000"
        data-old_color="#000000"
        fill="#FFFFFF"
      />
      <path
        d="m524.235 262.118-114.676-98.294v65.529h-49.147v65.529h49.147v65.529z"
        data-original="#000000"
        data-old_color="#000000"
        fill="#FFFFFF"
      />
    </g>{' '}
  </svg>
);

export default LogoutIcon;



// WEBPACK FOOTER //
// ./src/components/LogoutOverlay/LogoutIcon.js